"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 02 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ExportedPriceHistoryConverter_1 = require("./conversions/ExportedPriceHistoryConverter");

var ExportedPriceHistoryConverterImpl_1 = require("./conversions/ExportedPriceHistoryConverterImpl");

var ExportedPriceListRowConverter_1 = require("./conversions/ExportedPriceListRowConverter");

var ExportedPriceListRowConverterImpl_1 = require("./conversions/ExportedPriceListRowConverterImpl");

var ExportedPriceWithValidityConverter_1 = require("./conversions/ExportedPriceWithValidityConverter");

var ExportedPriceWithValidityConverterImpl_1 = require("./conversions/ExportedPriceWithValidityConverterImpl");

var PriceCodeSettingsConverter_1 = require("./conversions/PriceCodeSettingsConverter");

var PriceCodeSettingsConverterImpl_1 = require("./conversions/PriceCodeSettingsConverterImpl");

var PriceListConverter_1 = require("./conversions/PriceListConverter");

var PriceListConverterImpl_1 = require("./conversions/PriceListConverterImpl");

var PriceListRowConverter_1 = require("./conversions/PriceListRowConverter");

var PriceListRowConverterImpl_1 = require("./conversions/PriceListRowConverterImpl");

var PriceListRowDTOConverter_1 = require("./conversions/PriceListRowDTOConverter");

var PriceListRowDTOConverterImpl_1 = require("./conversions/PriceListRowDTOConverterImpl");

var PriceListSettingsConverter_1 = require("./conversions/PriceListSettingsConverter");

var PriceListSettingsConverterImpl_1 = require("./conversions/PriceListSettingsConverterImpl");

var PurchasePriceRowConverter_1 = require("./conversions/PurchasePriceRowConverter");

var PurchasePriceRowConverterImpl_1 = require("./conversions/PurchasePriceRowConverterImpl");
/**
 *
 * @author RV
 */


var PriceListAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(PriceListAppModule, _AppModule_1$AppModul);

  function PriceListAppModule() {
    var _this;

    _classCallCheck(this, PriceListAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceListAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'priceListAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceListAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ExportedPriceHistoryConverter_1.ExportedPriceHistoryConverter).to(ExportedPriceHistoryConverterImpl_1.ExportedPriceHistoryConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedPriceWithValidityConverter_1.ExportedPriceWithValidityConverter).to(ExportedPriceWithValidityConverterImpl_1.ExportedPriceWithValidityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceListConverter_1.PriceListConverter).to(PriceListConverterImpl_1.PriceListConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceListRowConverter_1.PriceListRowConverter).to(PriceListRowConverterImpl_1.PriceListRowConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedPriceListRowConverter_1.ExportedPriceListRowConverter).to(ExportedPriceListRowConverterImpl_1.ExportedPriceListRowConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PurchasePriceRowConverter_1.PurchasePriceRowConverter).to(PurchasePriceRowConverterImpl_1.PurchasePriceRowConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceListSettingsConverter_1.PriceListSettingsConverter).to(PriceListSettingsConverterImpl_1.PriceListSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceCodeSettingsConverter_1.PriceCodeSettingsConverter).to(PriceCodeSettingsConverterImpl_1.PriceCodeSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceListRowDTOConverter_1.PriceListRowDTOConverter).to(PriceListRowDTOConverterImpl_1.PriceListRowDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return PriceListAppModule;
}(AppModule_1.AppModule);

exports.PriceListAppModule = PriceListAppModule;